import { Component } from '@angular/core';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Cell-Komponente für die Titel-Spalte in der Announcement-Tabelle.
 *
 * Zeigt den Titel des Announcements an. Bei zu langem Text wird
 * dieser mit Ellipsis abgeschnitten und der volle Text als Tooltip angezeigt.
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-title-cell',
  standalone: true,
  templateUrl: './title-cell.component.html',
  styleUrls: ['./title-cell.component.scss'],
})
export class TitleCellComponent extends BaseCellComponent<AnnouncementTableItem> {}
